(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Cart items fade-up animation with Intersection Observer
  const cartItems = document.querySelector('.cart-items');
  
  if (cartItems) {
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      const animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Add a small delay for a more polished effect
            setTimeout(() => {
              entry.target.classList.add('animate-in');
              
              // Add 'loaded' class after all animations complete
              // Calculate the longest delay (last item) + animation duration
              const totalItems = entry.target.children.length;
              const lastItemDelay = 0.1 + (totalItems - 1) * 0.05; // 0.1s base + 0.05s per item
              const animationDuration = 0.6; // 0.6s animation duration
              const totalTime = (lastItemDelay + animationDuration) * 1000; // Convert to milliseconds
              
              setTimeout(() => {
                entry.target.classList.add('loaded');
              }, totalTime);
            }, 100);
            // Stop observing once animation is triggered
            animationObserver.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '50px 0px', // Start animation 50px before cart items enter viewport
        threshold: 0.1
      });
      
      animationObserver.observe(cartItems);
    } else {
      // Fallback for browsers without Intersection Observer
      setTimeout(() => {
        cartItems.classList.add('animate-in');
        
        // Add 'loaded' class after animations complete
        const totalItems = cartItems.children.length;
        const lastItemDelay = 0.1 + (totalItems - 1) * 0.05;
        const animationDuration = 0.6;
        const totalTime = (lastItemDelay + animationDuration) * 1000;
        
        setTimeout(() => {
          cartItems.classList.add('loaded');
        }, totalTime);
      }, 200);
    }
  }

  // Handle image loading states to prevent layout shift
  const cartImages = document.querySelectorAll('.cart-item__image img');
  
  cartImages.forEach(function(img) {
    const imageContainer = img.closest('.cart-item__image');
    
    // Add loaded class when image finishes loading
    img.addEventListener('load', function() {
      imageContainer.classList.add('loaded');
    });
    
    // Handle error case
    img.addEventListener('error', function() {
      imageContainer.classList.add('loaded');
      // Optionally add a placeholder or error state
      imageContainer.style.background = '#f0f0f0';
    });
    
    // If image is already loaded (cached), add loaded class immediately
    if (img.complete && img.naturalHeight !== 0) {
      imageContainer.classList.add('loaded');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Collection grid fade-up animation with Intersection Observer
  document.addEventListener('DOMContentLoaded', function() {
    const collectionProducts = document.querySelector('.collection-products');
    
    if (collectionProducts) {
      // Check if Intersection Observer is supported
      if ('IntersectionObserver' in window) {
        const animationObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Add a small delay for a more polished effect
              setTimeout(() => {
                entry.target.classList.add('animate-in');
                
                // Add 'loaded' class after all animations complete
                // Calculate the longest delay (last item) + animation duration
                const totalItems = entry.target.children.length;
                const lastItemDelay = 0.1 + (totalItems - 1) * 0.05; // 0.1s base + 0.05s per item
                const animationDuration = 0.6; // 0.6s animation duration
                const totalTime = (lastItemDelay + animationDuration) * 1000; // Convert to milliseconds
                
                setTimeout(() => {
                  entry.target.classList.add('loaded');
                }, totalTime);
              }, 100);
              // Stop observing once animation is triggered
              animationObserver.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '50px 0px', // Start animation 50px before grid enters viewport
          threshold: 0.1
        });
        
        animationObserver.observe(collectionProducts);
      } else {
        // Fallback for browsers without Intersection Observer
        setTimeout(() => {
          collectionProducts.classList.add('animate-in');
          
          // Add 'loaded' class after animations complete
          const totalItems = collectionProducts.children.length;
          const lastItemDelay = 0.1 + (totalItems - 1) * 0.05;
          const animationDuration = 0.6;
          const totalTime = (lastItemDelay + animationDuration) * 1000;
          
          setTimeout(() => {
            collectionProducts.classList.add('loaded');
          }, totalTime);
        }, 200);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile navigation toggle functionality
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.getElementById('mobileMenuButton');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const menuText = document.getElementById('menuText');
    
    if (mobileMenuButton && mobileNavOverlay && menuText) {
      // Only add mobile menu functionality if viewport is 768px or less
      function isMobileViewport() {
        return window.innerWidth <= 768;
      }

      mobileMenuButton.addEventListener('click', function() {
        // Only handle click if in mobile viewport
        if (!isMobileViewport()) return;
        
        const isOpen = mobileNavOverlay.classList.contains('mobile-nav-overlay--open');
        
        if (isOpen) {
          // Close the menu
          mobileNavOverlay.classList.remove('mobile-nav-overlay--open');
          menuText.textContent = 'MENU';
          document.body.classList.remove('mobile-nav-open');
          // Show homepage nav when menu is closed
          const mobileHomepageNav = document.querySelector('.mobile-homepage-nav');
          if (mobileHomepageNav) {
            mobileHomepageNav.style.display = 'block';
          }
        } else {
          // Open the menu
          mobileNavOverlay.classList.add('mobile-nav-overlay--open');
          menuText.textContent = 'CLOSE';
          document.body.classList.add('mobile-nav-open');
          // Hide homepage nav when menu is open
          const mobileHomepageNav = document.querySelector('.mobile-homepage-nav');
          if (mobileHomepageNav) {
            mobileHomepageNav.style.display = 'none';
          }
        }
      });
      
      // Close menu when clicking on overlay background
      mobileNavOverlay.addEventListener('click', function(e) {
        // Only handle click if in mobile viewport
        if (!isMobileViewport()) return;
        
        if (e.target === mobileNavOverlay) {
          mobileNavOverlay.classList.remove('mobile-nav-overlay--open');
          menuText.textContent = 'MENU';
          document.body.classList.remove('mobile-nav-open');
          // Show homepage nav when menu is closed
          const mobileHomepageNav = document.querySelector('.mobile-homepage-nav');
          if (mobileHomepageNav) {
            mobileHomepageNav.style.display = 'block';
          }
        }
      });
      
      // Close menu when clicking on nav links
      const mobileNavLinks = mobileNavOverlay.querySelectorAll('.mobile-nav__link');
      mobileNavLinks.forEach(link => {
        link.addEventListener('click', function() {
          // Only handle click if in mobile viewport
          if (!isMobileViewport()) return;
          
          mobileNavOverlay.classList.remove('mobile-nav-overlay--open');
          menuText.textContent = 'MENU';
          document.body.classList.remove('mobile-nav-open');
          // Show homepage nav when menu is closed
          const mobileHomepageNav = document.querySelector('.mobile-homepage-nav');
          if (mobileHomepageNav) {
            mobileHomepageNav.style.display = 'block';
          }
        });
      });
    }

    // Trigger fade-in animation for mobile homepage nav items
    const mobileHomepageNav = document.querySelector('.mobile-homepage-nav');
    if (mobileHomepageNav) {
      // Add a small delay to ensure the page is fully loaded
      setTimeout(() => {
        mobileHomepageNav.classList.add('animate-in');
      }, 100);
    }

    // Trigger fade-in animation for desktop header nav items (homepage only)
    const headerNav = document.querySelector('.header__nav--light');
    if (headerNav) {
      // Add a small delay to ensure the page is fully loaded
      setTimeout(() => {
        headerNav.classList.add('animate-in');
      }, 50);
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-banner"] && !Shopify.designMode) return;
  try {
    
  // Trigger fade-in animation for photo banner text elements
  document.addEventListener('DOMContentLoaded', function() {
    const photoBannerText = document.querySelector('.photo-banner__text');
    if (photoBannerText) {
      // Add a small delay to ensure the page is fully loaded
      setTimeout(() => {
        photoBannerText.classList.add('animate-in');
      }, 200);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Carousel functionality
  const carousel = document.getElementById('product-carousel');
  if (carousel) {
    const track = carousel.querySelector('.carousel-track');
    const slides = carousel.querySelectorAll('.carousel-slide');
    const prevBtn = carousel.querySelector('.carousel-btn--prev');
    const nextBtn = carousel.querySelector('.carousel-btn--next');
    const indicators = carousel.querySelectorAll('.carousel-indicator');
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    // Check if we're on mobile viewport
    function isMobileViewport() {
      return window.innerWidth <= 768;
    }
    
    // Only initialize carousel if there are multiple images AND we're on mobile
    if (totalSlides > 1 && isMobileViewport()) {
      // Update carousel position
      function updateCarousel() {
        const translateX = -currentSlide * 100;
        track.style.transform = `translateX(${translateX}%)`;
        
        // Update indicators
        indicators.forEach((indicator, index) => {
          indicator.classList.toggle('active', index === currentSlide);
        });
        
        // Update button states
        prevBtn.disabled = currentSlide === 0;
        nextBtn.disabled = currentSlide === totalSlides - 1;
      }
      
      // Go to specific slide
      function goToSlide(slideIndex) {
        if (slideIndex >= 0 && slideIndex < totalSlides) {
          currentSlide = slideIndex;
          updateCarousel();
        }
      }
      
      // Next slide
      function nextSlide() {
        if (currentSlide < totalSlides - 1) {
          currentSlide++;
          updateCarousel();
        }
      }
      
      // Previous slide
      function prevSlide() {
        if (currentSlide > 0) {
          currentSlide--;
          updateCarousel();
        }
      }
      
      // Touch/swipe functionality
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      let currentX = 0;
      let initialTransform = 0;
      
      function handleTouchStart(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        initialTransform = -currentSlide * 100;
        track.style.transition = 'none';
      }
      
      function handleTouchMove(e) {
        if (!isDragging) return;
        
        currentX = e.touches[0].clientX;
        const diffX = currentX - startX;
        const diffY = Math.abs(e.touches[0].clientY - startY);
        
        // Only handle horizontal swipes
        if (Math.abs(diffX) > diffY) {
          e.preventDefault();
          const translateX = initialTransform + (diffX / track.offsetWidth) * 100;
          track.style.transform = `translateX(${translateX}%)`;
        }
      }
      
      function handleTouchEnd(e) {
        if (!isDragging) return;
        
        isDragging = false;
        track.style.transition = 'transform 0.3s ease-in-out';
        
        const diffX = currentX - startX;
        const threshold = track.offsetWidth * 0.2; // 20% threshold
        
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0 && currentSlide > 0) {
            prevSlide();
          } else if (diffX < 0 && currentSlide < totalSlides - 1) {
            nextSlide();
          } else {
            updateCarousel();
          }
        } else {
          updateCarousel();
        }
      }
      
      // Mouse drag functionality for desktop
      function handleMouseDown(e) {
        startX = e.clientX;
        isDragging = true;
        initialTransform = -currentSlide * 100;
        track.style.transition = 'none';
        e.preventDefault();
      }
      
      function handleMouseMove(e) {
        if (!isDragging) return;
        
        currentX = e.clientX;
        const diffX = currentX - startX;
        const translateX = initialTransform + (diffX / track.offsetWidth) * 100;
        track.style.transform = `translateX(${translateX}%)`;
      }
      
      function handleMouseUp(e) {
        if (!isDragging) return;
        
        isDragging = false;
        track.style.transition = 'transform 0.3s ease-in-out';
        
        const diffX = currentX - startX;
        const threshold = track.offsetWidth * 0.2;
        
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0 && currentSlide > 0) {
            prevSlide();
          } else if (diffX < 0 && currentSlide < totalSlides - 1) {
            nextSlide();
          } else {
            updateCarousel();
          }
        } else {
          updateCarousel();
        }
      }
      
      // Event listeners
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      
      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => goToSlide(index));
      });
      
      // Touch events
      track.addEventListener('touchstart', handleTouchStart, { passive: false });
      track.addEventListener('touchmove', handleTouchMove, { passive: false });
      track.addEventListener('touchend', handleTouchEnd);
      
      // Mouse events for desktop
      track.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      
      // Initialize carousel
      updateCarousel();
      
      // Handle window resize to disable carousel on desktop
      function handleResize() {
        if (!isMobileViewport()) {
          // Reset carousel state for desktop
          track.style.transform = 'none';
          track.style.transition = 'none';
          track.style.display = 'flex';
          track.style.flexDirection = 'column';
          currentSlide = 0;
          
          // Remove event listeners
          if (prevBtn) prevBtn.removeEventListener('click', prevSlide);
          if (nextBtn) nextBtn.removeEventListener('click', nextSlide);
          
          indicators.forEach((indicator, index) => {
            indicator.removeEventListener('click', () => goToSlide(index));
          });
          
          track.removeEventListener('touchstart', handleTouchStart);
          track.removeEventListener('touchmove', handleTouchMove);
          track.removeEventListener('touchend', handleTouchEnd);
          track.removeEventListener('mousedown', handleMouseDown);
          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp);
        }
      }
      
      // Listen for resize events
      window.addEventListener('resize', handleResize);
    } else if (totalSlides > 1 && !isMobileViewport()) {
      // On desktop, ensure carousel track displays vertically
      track.style.transform = 'none';
      track.style.transition = 'none';
      track.style.display = 'flex';
      track.style.flexDirection = 'column';
    }
  }
  
  // Product form functionality
  const productForm = document.getElementById('product-form');
  const variantSelect = document.getElementById('product-variant');
  const addToCartButton = productForm ? productForm.querySelector('button[type="submit"]') : null;
  const priceElement = document.querySelector('.product-price');
  
  if (!productForm) return;
  
  // Function to format price
  function formatPrice(cents) {
    const price = (cents / 100).toFixed(2);
    return `$${price}`;
  }
  
  // Handle form submission
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    // Get form data
    const formData = new FormData(productForm);
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;
    
    // Show loading state
    addToCartButton.disabled = true;
    addToCartButton.textContent = 'Adding To Cart';
    
    // Add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: parseInt(quantity)
      })
    })
    .then(response => response.json())
    .then(data => {
      // Success - update button text briefly
      addToCartButton.textContent = 'Added To Cart';
      addToCartButton.style.backgroundColor = 'var(--color-beige)';
      
      // Trigger cart update event
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Reset button after delay
      setTimeout(() => {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Add To Cart';
        addToCartButton.style.backgroundColor = 'transparent';
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Show error state
      addToCartButton.textContent = 'Error Adding To Cart';
      addToCartButton.style.backgroundColor = '#ff4444';
      
      // Reset button after delay
      setTimeout(() => {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Add To Cart';
        addToCartButton.style.backgroundColor = 'transparent';
      }, 3000);
    });
  });
  
  // Handle variant selection
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      const selectedVariantId = this.value;
      const selectedOption = this.options[this.selectedIndex];
      const isAvailable = !selectedOption.disabled;
      
      // Update button state based on availability
      addToCartButton.disabled = !isAvailable;
      if (isAvailable) {
        addToCartButton.textContent = 'Add To Cart';
      } else {
        addToCartButton.textContent = 'Sold Out';
      }
      
      // Update price if price element exists
      if (priceElement) {
        // Extract price from the option text (format: "Variant Title - $XX.XX")
        const optionText = selectedOption.textContent;
        const priceMatch = optionText.match(/\$[\d,]+\.?\d*/);
        if (priceMatch) {
          priceElement.textContent = priceMatch[0];
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
